export default {
  header: {
    title: 'Buy gift card',
  },
  checkout_btn: {
    title: 'Checkout',
    max_quantity: 'At most {{max}} gift cards per purchase',
  },
  items: {
    gift_card: {
      online: 'Gift card redeemable online only',
      online_and_store: 'Gift card (redeemable online & in store)',
      title: 'Select your desired amount',
      description: 'Add the gift card with the desired quantity to the cart',
    },
    expiration: {
      label: 'Valid for 3 years',
      title: 'Enjoy gifting!',
      description: 'The recipient can redeem the voucher flexibly within 3 years.',
    },
    delivery: {
      label: 'Delivery immediately as a PDF via email',
      title: 'Instant delivery as a PDF via email',
      description: 'After secure payment you will receive the voucher immediately.',
    },
  },
  form: {
    value: {
      title: 'Choose the gift card amount',
      custom: {
        label: 'Custom',
        placeholder: 'Enter amount between {{min}} and {{max}} {{currency}}',
      },
    },
    quantity: {
      title: 'Quantity',
    },
    email: {
      title: 'What is your email address so we can send you the gift card?',
      placeholder: 'Your email address',
      error: 'Invalid email',
    },
  },
  confirmation: {
    title: {
      title: 'Buy gift card?',
      subtitle_one: 'Would you like to buy 1 gift card for {{value}}?',
      subtitle_other: 'Would you like to buy {{count}} gift cards for {{value}}?',
    },
    description: {
      total: 'Total:',
      email: 'E-Mail:',
      quantity: 'Quantity',
      amount: 'Amount',
    },
    footer: {
      cancel: 'Cancel',
      confirm: 'Confirm',
    },
  },
};
